module.exports = __webpack_public_path__ + "img/file-spreadsheet.5a93fae6.svg";